import { useQuery, QueryOptions, UseQueryResult } from '@tanstack/react-query'

import { fetchInvoice } from '@pepper/utils/src/api/invoices/invoices-v2'

interface Argument {
  invoiceId: string
}

export function useInvoice(
  { invoiceId }: Argument,
  config?: QueryOptions<any | undefined, Error>
): UseQueryResult<any | undefined, Error> {
  return useQuery({
    queryKey: [`/invoices/:${invoiceId}`],
    queryFn: async () => {
      const response = await fetchInvoice({ invoiceId })
      if (response.error) {
        throw response.error
      } else {
        return response.data
      }
    },
    ...config
  })
}
